import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconDeepMind: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2689_6510)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2325 4.86542C9.92024 6.14888 8.90795 7.70658 8.26808 9.42701C7.62822 11.1474 7.3766 12.988 7.53125 14.8171C8.04021 21.2454 14.1025 26.4765 19.6004 26.4765C24.7148 26.4765 26.7171 22.0125 26.2227 18.9806C26.0401 17.867 25.5616 16.8229 24.8373 15.9575C25.759 16.4533 26.6515 17.0892 27.4754 17.8533C29.6921 19.9169 31.0338 22.5623 31.2481 25.2908C31.725 31.321 27.2625 37.5 19.8002 37.5C17.3283 37.5 14.7252 36.87 12.5377 35.8331C6.60667 33.0331 2.5 26.9956 2.5 20.0029C2.5 13.541 6.00729 7.89583 11.2325 4.86542ZM20.1983 2.5C22.6717 2.5 25.2748 3.13 27.4608 4.16688C33.3962 6.96688 37.5 13.0044 37.5 19.9971C37.5 26.459 33.9927 32.1056 28.7675 35.1346C30.0798 33.8511 31.0921 32.2934 31.7319 30.573C32.3718 28.8526 32.6234 27.012 32.4688 25.1829C31.9598 18.7546 25.8975 13.5235 20.3996 13.5235C15.2852 13.5235 13.2829 17.9875 13.7773 21.0194C13.9599 22.1338 14.4401 23.1783 15.1671 24.0425C14.2098 23.526 13.3227 22.8889 12.5275 22.1467C10.3108 20.0831 8.96917 17.4406 8.75188 14.7092C8.275 8.67896 12.7375 2.5 20.1998 2.5H20.1983Z"
        fill="#4285F4"
      />
    </g>
    <defs>
      <clipPath id="clip0_2689_6510">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconDeepMind.defaultProps = defaultIconProps;
